import React, { useEffect, useRef, useState } from 'react'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import EditMenu from '../editMenu'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import './artistMaxCarousel.css'
import { isEmpty } from 'lodash'
import PassimPlayer from '../rosemary/passimPlayer'

const ArtistMax = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
  isPlayer = false,
  withoutText = false,
}) => {
  const { data, id } = componentData
  const { customNavigate, getTemplateImage, TriangleIcon } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')
  const [current, setCurrent] = useState(0)
  const touchStartX = useRef(null)
  const touchEndX = useRef(null)

  useEffect(() => {
    if (!data?.auto_slide) return
    const timer = setInterval(() => {
      nextSlide()
    }, 3000)
    return () => clearInterval(timer)
  }, [current, data?.auto_slide])

  useEffect(() => {
    if (data) setCurrent(0)
  }, [data])

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? data.slide_data.length - 1 : prev - 1))
  }

  const nextSlide = () => {
    setCurrent((prev) => (prev === data.slide_data.length - 1 ? 0 : prev + 1))
  }

  const getPosition = (index) => {
    if (index === current) return 'center'
    if (index === (current + 1) % data.slide_data.length) return 'right'
    if (index === (current - 1 + data.slide_data.length) % data.slide_data.length) return 'left'
    return 'hidden'
  }

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX
  }

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX
  }

  const handleTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return
    const distance = touchStartX.current - touchEndX.current

    if (distance > 50) nextSlide() // Swipe Left
    if (distance < -50) prevSlide() // Swipe Right

    touchStartX.current = null
    touchEndX.current = null
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'} py-8`}
      style={{ backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1) }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div
        className="flex items-baseline "
        style={{
          padding: '0 5.52%',
        }}
      >
        <p
          style={{
            color: getStyleValue('title', 'color', theme.c3),
            fontFamily: getStyleValue('title', 'font', ''),
            textAlign: getStyleValue('title', 'alignment', 'left'),
          }}
          className={`sm:text-[0.8rem] md:text-[1.5rem] font-bold w-full ${getStyleValue(
            'title',
            'font_format',
            'font-bold',
          )}`}
        >
          {data?.title}
        </p>
      </div>
      <div
        className="artist-max-container"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <button
          style={{ left: '10px' }}
          className="artist-max-nav-btn artist-left-btn"
          onClick={prevSlide}
        >
          <img src={TriangleIcon} alt="Triangle" className="rotate-180" />
        </button>

        <div className="artist-max-track">
          {!isEmpty(data?.slide_data)
            ? data?.slide_data.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`artist-max-item overflow-hidden  ${getPosition(index)} `}
                    style={{ background: `${item.color}` }}
                    onClick={() => handleRedirect(item.link)}
                  >
                    {!isEdit && isPlayer && item?.player?.type && current === index ? (
                      <div className=" w-full h-full overflow-hidden">
                        <PassimPlayer
                          data={item?.player}
                          poster={getTemplateImage(item?.image_s3key)}
                          controlBar={false}
                          isBanner={true}
                          iconPositionClass={''}
                          onClickRedirect={() => handleRedirect(item.link)}
                        />
                      </div>
                    ) : (
                      <CustomImage
                        imageUrl={getTemplateImage(item?.image_s3key)}
                        imgClass="w-full h-full "
                        imgStyle={{}}
                        loaderClass="w-full h-full"
                        loaderStyle={{ background: '#5A5A5A50' }}
                        imgAlt={'trainer'}
                      />
                    )}

                    {!withoutText && current === index && (
                      <div
                        style={{
                          color: 'white',
                          // backgroundImage:
                          //   'linear-gradient(91deg, rgba(0, 0, 0, 0) 1%, rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 0.9) 90%)',
                          backgroundColor: 'rgba(0, 0, 0, 0.6)',
                          // height: '91.6%',
                        }}
                        className=" absolute right-0 w-1/2 xl:w-2/5 2xl:w-[35%] flex flex-col justify-center items-end mr-[1vw] 
                        rounded-md xl:rounded-[10px] h-[91.6%] xl:h-[95%] 2xl:h-[91.6%]"
                      >
                        <div className="px-[8px] xl:px-[1vw] w-full">
                          <p
                            style={{
                              color: getStyleValue('heading', 'color', '#fff'),
                              fontFamily: getStyleValue('heading', 'font', ''),
                              textAlign: getStyleValue('heading', 'alignment', ''),
                            }}
                            className={` xl:text-lg md:text-base sm:text-sm text-[10px] font-bold mb-[8px]
                             ${getStyleValue('heading', 'font_format', 'font-bold')}
                            `}
                          >
                            {item?.heading}
                          </p>
                          <p
                            style={{
                              color: getStyleValue('sub_heading', 'color', '#bcbcbc'),
                              fontFamily: getStyleValue('sub_heading', 'font', ''),
                              textAlign: getStyleValue('sub_heading', 'alignment', ''),
                            }}
                            className={`sm:text-xs text-[10px] sm:leading-5 line-clamp-7
                                ${getStyleValue('sub_heading', 'font_format', '')}
                              `}
                          >
                            {item?.sub_heading}
                          </p>
                          <p
                            style={{
                              color: getStyleValue('categories', 'color', '#fff'),
                              fontFamily: getStyleValue('categories', 'font', ''),
                              textAlign: getStyleValue('categories', 'alignment', ''),
                            }}
                            className={`hidden xl:block xl:text-xs md:text-xs sm:text-xs text-[10px] sm:leading-5 mt-[12px] mb-0
                               ${getStyleValue('categories', 'font_format', 'font-bold')}
                              `}
                          >
                            {item?.categories?.heading}
                          </p>
                          <div
                            style={{
                              fontFamily: getStyleValue('metadata1', 'font', ''),
                              textAlign: getStyleValue('metadata1', 'alignment', ''),
                            }}
                            className={` ${getStyleValue('metadata1', 'font_format', '')}`}
                          >
                            <p
                              style={{ color: getStyleValue('metadata1', 'heading_color', '#fff') }}
                              className="hidden lg:block xl:text-xs md:text-xs sm:text-xs text-[10px] sm:leading-5 mb-0 mt-[12px] font-bold"
                            >
                              {item?.metadata1?.heading}
                            </p>
                            <p
                              style={{
                                color: getStyleValue('metadata1', 'value_color', '#bcbcbc'),
                              }}
                              className="hidden lg:block xl:text-xs md:text-xs sm:text-xs text-[10px] sm:leading-5 mb-0"
                            >
                              {item?.metadata1?.value}
                            </p>
                          </div>
                          <div
                            style={{
                              color: getStyleValue('metadata2', 'color', '#fff'),
                              fontFamily: getStyleValue('metadata2', 'font', ''),
                              textAlign: getStyleValue('metadata2', 'alignment', ''),
                            }}
                            className={` ${getStyleValue('metadata2', 'font_format', '')}`}
                          >
                            <p
                              style={{ color: getStyleValue('metadata2', 'heading_color', '#fff') }}
                              className="hidden lg:block xl:text-xs md:text-xs sm:text-xs text-[10px] sm:leading-5 mb-0 mt-[12px] font-bold"
                            >
                              {item?.metadata2?.heading}
                            </p>
                            <p
                              style={{
                                color: getStyleValue('metadata2', 'value_color', '#bcbcbc'),
                              }}
                              className="hidden lg:block xl:text-xs md:text-xs sm:text-xs text-[10px] sm:leading-5 mb-0"
                            >
                              {item?.metadata2?.value}
                            </p>
                          </div>
                        </div>

                        {item?.cta_button?.enabled && item.cta_button.text && (
                          <div className="mr-[8px] xl:mr-[1vw] mt-[8px] md:mt-4 xl:mt-[1vw]">
                            <button
                              style={{
                                borderRadius: '6px',
                                backgroundImage: `linear-gradient(to ${getStyleValue(
                                  'button',
                                  'gradient',
                                  'left',
                                )}, ${getStyleValue(
                                  'button',
                                  'primary_color',
                                  theme.c2,
                                )}, ${getStyleValue('button', 'secondary_color', theme.c2)})`,
                                color: getStyleValue('button', 'text_color', '#fff'),
                              }}
                              className="border-0 py-[8px] px-6 text-xs md:text-sm"
                            >
                              {item.cta_button.text}
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )
              })
            : null}
        </div>
        <div className="w-full flex justify-center items-center absolute bottom-0">
          {!isEmpty(data?.slide_data)
            ? data?.slide_data.map((i, idx) => {
                return (
                  <div
                    style={{
                      background: `${getStyleValue('dots_color', 'color', '#fff')}${
                        current === idx ? '' : '70'
                      } `,
                    }}
                    className="rounded-full w-1 md:w-[8px] aspect-square mx-1 md:mx-2 cursor-pointer"
                    onClick={() => setCurrent(idx)}
                    key={idx}
                  ></div>
                )
              })
            : null}
        </div>

        <button
          style={{ right: '10px' }}
          className="artist-max-nav-btn artist-right-btn"
          onClick={nextSlide}
        >
          <img src={TriangleIcon} alt="Triangle" className="" />
        </button>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(ArtistMax)
